<template>
  <!-- 銀行卡 / 電子錢包選單（非加密幣才顯示） -->
  <div class="colu-12" :class="isPC ? 'fun-withdraw-bank' : 'fun-withdraw-bank-mb'">
    <label class="colu-12 for-label">
      {{ $t('Bao.card_or_address') }}
    </label>
    <div class="row-frame">
      <div :class="isPC ? 'colu colu-9' : 'colu colu-8'">
        <div
          class="custom-select-wrap"
          :data-value="selectedBankId"
        >
          <button
            class="cs-btn"
            type="button"
            @click="isBankDropdownOpen = !isBankDropdownOpen"
          >
            {{ selectedBankName }}
          </button>
          <ul class="cs-list" :class="{ active: isBankDropdownOpen }">
            <!-- 預設佔位選項 -->
            <li
              v-if="!selectedBankId || isNaN(selectedBankId)"
              :data-value="selectedBankName"
              class="selected"
              @click="selectBank({ id: null, card_number: selectedBankName })"
            >
              {{ selectedBankName }}
            </li>
            <!-- 銀行列表 -->
            <li
              v-for="(bank, key) in myBanks"
              :key="key"
              :data-value="bank.id"
              :class="{ selected: selectedBankId === bank.id }"
              @click="selectBank(bank)"
            >
              {{ bank.card_number }}
            </li>
          </ul>
        </div>
      </div>
      <div :class="isPC ? 'colu colu-3' : 'colu colu-4'">
        <button
          class="btn button-style btn-creat"
          @click.prevent="$router.push('/user/bank')"
        >
          <img :src="$getThemeImagePath('add.svg')" alt="">
          {{ $t('Bao.new_bank_card_1') }}{{ $t('Bao.new_bank_card_2') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { detectMob } from '@/utils/tool'

export default {
  name: 'PaymentUseBank',
  inject: {
    errors: { default: () => ({ has: () => false }) }
  },
  props: {
    myBanks: {
      type: Array,
      default: () => []
    },
    /** 目前選中的銀行 id */
    selectedBankId: {
      type: [String, Number],
      default: null
    },
    /** 目前顯示的銀行名稱 */
    selectedBankName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isBankDropdownOpen: false
    }
  },
  computed: {
    isPC() {
      return !detectMob()
    }
  },
  methods: {
    selectBank(bank) {
      this.isBankDropdownOpen = false
      this.$emit('select-bank', bank)
    }
  }
}
</script>
